<template>
  <span>
    <DialogBase
      v-model="inputedValue.dialog"
      :title="$t('common.input_member-management')"
      :width="width"
      isPadding0="true"
    >
      <v-card class="content">
        <UserAdd v-model="userAddDialog" @add="init" />
        <NormalButton
          :text="'＋ ' + $t('user.user_add-member')"
          width="160px"
          height="40px"
          textSize="16px"
          v-if="isLoginUserAdmin"
          @click="openUserAddDialog"
          class="pt-4"
        />

        <span v-for="(value, key) in userList" :key="`users-${key}`">
          <p class="heading">
            {{
              key === 'users'
                ? $t('user.user_affiliated-member')
                : $t('user.user_inviting')
            }}
            ({{ value.length }})
          </p>

          <v-row align="center" v-for="(member, i) in value" :key="`key-${i}`">
            <v-col cols="1">
              <img
                :src="member.iconImgUrl ? member.iconImgUrl : defaultIcon"
                class="userIcon"
              />
            </v-col>

            <v-col cols="2">
              {{ member.lastName }} {{ member.firstName }}
            </v-col>
            <v-col cols="4">{{ member.email }}</v-col>
            <v-col cols="3">
              <span v-if="key === 'users' && isLoginUserAdmin">
                <SelectUserAuthority
                  v-model="member.authorityTmp"
                  @change="onChangeAuthority($event, i)"
                  :check="true"
                />
              </span>
              <span v-else>{{ member.authorityTmp.label }}</span>
            </v-col>

            <v-col cols="2" v-if="key === 'users' && isLoginUserAdmin">
              <NormalTextButton @click="onClickDelete(member)">
                <span class="deleteButtonStyle">{{
                  $t('common.input_delete')
                }}</span>
              </NormalTextButton>
            </v-col>
          </v-row>
        </span>
      </v-card>
    </DialogBase>
    <DialogAlertSuccess v-model="completeDialog" />
  </span>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBase from './DialogBase'
import NormalButton from '@/components/items/Buttons/NormalButton'
import NormalTextButton from '@/components/items/Buttons/NormalTextButton'
import { SelectUserAuthority } from '@/components/items/Selectboxes'

import { authorityConfig } from '@/config'
import { masterUtil } from '@/util'

import UserAdd from '@/components/layouts/Dialogs/UserAdd'
import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'

export default {
  components: {
    DialogBase,
    NormalButton,
    NormalTextButton,
    SelectUserAuthority,
    UserAdd,
    DialogAlertSuccess
  },
  props: {
    value: {
      dialog: false
    },
    width: { default: '600px' }
  },
  data: () => ({
    defaultIcon: require('@/assets/icon_user_default.png'),

    isLoginUserAdmin: false,
    userList: {
      users: [],
      invitations: []
    },
    authorityData: {},
    authorityChangeDialog: false,
    changeAuthorityData: {
      oldValue: '',
      newValue: ''
    },
    userAddDialog: false,
    changeUser: {},
    completeDialog: false
  }),

  methods: {
    ...mapActions('Auth', ['logout']),
    ...mapActions('User', [
      'getUserInfoFromApi',
      'getUserListFromApi',
      'setUserAuthority',
      'userLeave'
    ]),
    ...mapGetters('User', ['getUserInfoFromState', 'getUserListFromState']),

    async init() {
      await Promise.all([
        this.getUserListFromApi(),
        this.getUserInfoFromApi()
      ]).then((message) => {
        this.createData()
      })
    },

    openUserAddDialog() {
      this.userAddDialog = true
    },

    createData() {
      const loginUser = this.getUserInfoFromState()
      const UserList = this.getUserListFromState().map((ele) => {
        ele.isLoginUser = loginUser.id === ele.id
        ele.authorityTmp = this.getAuthority(ele.authorityId)
        return ele
      })

      this.isLoginUserAdmin =
        loginUser.authorityId === authorityConfig.AUTHORITY_TYPE_ID.ADMIN

      this.userList.users = UserList.filter(
        (ele) => !ele.invitedAt && !!ele.email
      )
      this.userList.invitations = UserList.filter(
        (ele) => ele.invitedAt && !!ele.email
      )
    },

    getAuthority(id) {
      return masterUtil.getAuthorityList().find((ele) => id === ele.value)
    },

    async onClickDelete(member) {
      const isConfirmed = confirm(
        `${this.$t('user.user_this-operation-cannot-be-undone')}\n${this.$t(
          'user.user_do-you-really-want-to-remove-this-member'
        )}`
      )
      if (isConfirmed) {
        const isSucceed = await this.userLeave({ userId: member.id })
        if (isSucceed) {
          alert(this.$t('user.user_member-delete'))

          if (member.isLoginUser) {
            await this.logout()
            this.inputedValue.dialog = false
            return
          }

          await this.init()
        }
      }
    },

    async onChangeAuthority(event, userIndex) {
      const changeUser = this.userList.users[userIndex]
      changeUser.authorityTmp = event
      this.changeUser = changeUser

      this.authorityData = [
        {
          userId: changeUser.id,
          authorityId: changeUser.authorityTmp.value
        }
      ]
      this.completeDialog = await this.setUserAuthority({
        userIdList: this.authorityData
      })
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.dialog) this.init()
      }
    },
    completeDialog: function (newVal, oldVal) {
      if (oldVal && !newVal) {
        // TODO 仮
        // this.init()
        this.userList.users = this.userList.users.filter((ele) => true)
        if (this.changeUser.isLoginUser) {
          this.isLoginUserAdmin =
            this.changeUser.authorityTmp.value ===
            authorityConfig.AUTHORITY_TYPE_ID.ADMIN

          this.changeUser = {}
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 30px !important;
}
.heading {
  margin-top: 16px;
  line-height: 32px;
}
.userIcon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.deleteButtonStyle {
  font-size: 14px;
}
.dialogCancelButtonStyle {
  color: #0095d9 !important;
}
.dialogDeleteButtonStyle {
  color: #cd4444 !important;
}
</style>
